export default __webpack_public_path__ + "1c2dfe423c30dd3d86ebf6fcec115a66.png";